const doc = [({"en":({"js":({"activities":({"index":({"card":({"description":({"read_less":"Read less", "read_more":"Read more"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;